import { CompetenciesFinderFactorialCompetencyFragment } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

export const sortFactorialCompetencies = (
  competencies: CompetenciesFinderFactorialCompetencyFragment[]
): CompetenciesFinderFactorialCompetencyFragment[] => {
  return orderBy(competencies, ['importance', 'name'], ['desc', 'asc'])
}
